/**
 * Reads what the API said from a failed request. The HTTP client's `HttpError` carries a generic
 * `message` ("Request failed with status 403") and a generic `errorKey`; the server's own sentence
 * and key travel in `response.data`.
 *
 * @module
 */

interface ServerErrorShape {
  response?: { data?: { error?: unknown; errorKey?: unknown } }
}

/**
 * The server's own sentence for a failed request.
 *
 * @param error - A thrown value.
 * @returns The `error` text the API sent, or null when it sent none.
 */
export function serverErrorMessage(error: unknown): string | null {
  const said = (error as ServerErrorShape | null | undefined)?.response?.data?.error
  return typeof said === 'string' && said.trim() ? said : null
}

/**
 * The server's machine-readable reason for a failed request.
 *
 * @param error - A thrown value.
 * @returns The `errorKey` the API sent, or null when it sent none.
 */
export function serverErrorKey(error: unknown): string | null {
  const key = (error as ServerErrorShape | null | undefined)?.response?.data?.errorKey
  return typeof key === 'string' && key ? key : null
}
